import HttpClient from '../HttpClient/LegacyApi';
import { map, concatAll, toArray } from "rxjs/operators";
import { of } from "rxjs";
import TheBestOffer from "../../entities/TheBestOffer";

export default {
    calculate(supplierId, grainId, transportCoefficeint, marginalProfit) {
        const data = `transportCoefficient=${transportCoefficeint}&marginalProfit=${marginalProfit}`;

        return HttpClient.get(`/supplier/${supplierId}/grains/${grainId}/calculateBestOffers?${data}`)
            .pipe(
                map(response => response.data),
                concatAll(offers => of(offers)),
                map((offer) => {
                    return new TheBestOffer(
                        offer.companyId,
                        offer.companyAddress,
                        offer.companyName,
                        offer.deliveryDistance,
                        offer.deliveryPrice,
                        offer.grainId,
                        offer.hasContract,
                        offer.lastCallDate,
                        offer.marginalProfit,
                        offer.purchasePrice,
                        offer.estimatedPrice,
                        offer.withOrWithoutVAT
                    );
                }),
                toArray(),
            );
    }
}



// WEBPACK FOOTER //
// ./apiClient/TheBestOffersCalculator/index.js